import { initMenu } from "./modules/_menu.js";
import { initContactForm } from "./modules/_contact-form.js";
import { initBackgroundScroll } from "./modules/_background-scroll.js";
import { initTabs } from "./modules/_tabs.js";
import { initAgendaLinks } from "./modules/_agenda-links.js";
import { initAudioPlayer } from "./modules/_audio-player.js";
import { initPastHighlights } from "./modules/_past-highlights.js";
import { initAnimations } from "./modules/_animations.js";
import { initHeroScroll } from "./modules/_hero-scroll.js";
import { deobfuscateEmails } from "./modules/_deobfuscate";
import { initPressSlideshow } from "./modules/_press-slideshow";
// Remove no-js class
document.querySelector(".no-js").classList.remove("no-js");

// Initialize all modules
initMenu();
initContactForm();
initAnimations();
initBackgroundScroll();
initHeroScroll();
initTabs();
initAgendaLinks();
initAudioPlayer();
initPastHighlights();
deobfuscateEmails();
initPressSlideshow();
